import { useEffect, useRef } from "react";

const isTypingTarget = (el) => {
  if (!el) return false;
  const tag = el.tagName;
  return (
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT" ||
    el.isContentEditable ||
    el.getAttribute?.("role") === "combobox"
  );
};

const isModalOpen = () =>
  document.body.classList.contains("ReactModal__Body--open") ||
  Boolean(document.querySelector("[data-ds-modal-open='true']"));

// Global single-key shortcuts. `bindings` maps a key (KeyboardEvent.key, with
// "Shift+" prefix where needed) to a handler. Keys are ignored while typing,
// with Ctrl/Meta/Alt held, or while a modal is open. "Escape" handlers also
// run while typing so that Esc can leave an input.
export default function useHotkeys(bindings, { enabled = true } = {}) {
  const bindingsRef = useRef(bindings);
  bindingsRef.current = bindings;

  useEffect(() => {
    if (!enabled) return undefined;
    const onKeyDown = (e) => {
      if (e.defaultPrevented || e.isComposing) return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (isModalOpen()) return;

      const typing = isTypingTarget(e.target);
      if (typing && e.key !== "Escape") return;

      const key = e.shiftKey && e.key.length > 1 ? `Shift+${e.key}` : e.key;
      const handler = bindingsRef.current[key];
      if (!handler) return;
      const handled = handler(e);
      if (handled !== false) e.preventDefault();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [enabled]);
}
